import React, { useState, useEffect } from "react";
import { Button } from "antd";
import { FileExcelOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import VendorTransactions from "./VendorTransactions";
import TransactionAdjustments from "./TransactionAdjustments";
import DateFilter from "../../../Components/DateFilter";
import { useDateFilter } from "../../../Contexts/DateFilterContext";
import * as XLSX from "xlsx";
import GenericStatCard from "../../../Components/Cards/GenericStatCard";
import summaryIcon from "../../../Assets/Icons/oil_barrel.svg";
import { getVendorTransactions } from "../../../API/FuelVendor/Transactions";
import usePageAccess from "../../../Utlis/usePageAccess";

const Transactions = () => {
  const { canEdit } = usePageAccess("transactions");
  const location = useLocation();
  const [exportData, setExportData] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [summary, setSummary] = useState(null);

  const [activeTab, setActiveTab] = useState(
    location.state?.activeTab || "Transactions",
  );

  const [btnConfigs, setBtnConfigs] = useState([]);
  const { from, to } = useDateFilter();

  const tabs = ["Transactions", "Transaction Adjustments"];

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const startDate = from ? from.split(" ")[0] : undefined;
        const endDate = to ? to.split(" ")[0] : undefined;

        const res = await getVendorTransactions(startDate, endDate);

        if (Math.floor(res?.status / 100) === 2) {
          const data = res?.data?.data;

          setTransactions(data?.transactions || []);
          setSummary(data?.summary || null);
        }
      } catch (err) {
        console.error("Failed to load transactions:", err);
      }
    };

    fetchTransactions();
  }, [from, to]);

  const handleExport = () => {
    if (exportData.length === 0) {
      return;
    }

    const excludedKeys = ["key", "vendorAvatar"];
    const fields = Object.keys(exportData[0]).filter(
      (field) => !excludedKeys.includes(field),
    );

    const rows = exportData.map((row) =>
      fields.reduce((acc, field) => {
        acc[field] = row[field] ?? "-";
        return acc;
      }, {}),
    );

    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, activeTab);

    XLSX.writeFile(workbook, `${activeTab}.xlsx`);
  };

  return (
    <div className="report system-configue transaction-vendor">
      <div className="date-filter-top">
        <DateFilter />
      </div>
      {activeTab !== "Transaction Adjustments" && (
        <div className="stats-container">
          {(summary?.by_fuel_type || []).map((fuelType) => (
            <div className="stats-container-card" key={fuelType.fuel_type_id}>
              <GenericStatCard
                title={fuelType.fuel_type_name}
                value={`${fuelType.total_volume} L`}
                icon={summaryIcon}
                subtitle={`$${(parseFloat(fuelType.total_amount) || 0).toFixed(2)}`}
              />
            </div>
          ))}
        </div>
      )}
      <div className="transaction-header">
        <div className="export-wrapper">
          <Button
            type="primary"
            icon={<FileExcelOutlined />}
            className="export-pdf-btn"
            onClick={handleExport}
          >
            Export
          </Button>
        </div>
      </div>

      <div className="header-wrapper">
        <div className="report-navigation">
          <div className="nav-tabs">
            {tabs.map((tab) => (
              <button
                key={tab}
                className={`nav-item ${activeTab === tab ? "active" : ""}`}
                onClick={() => {
                  setActiveTab(tab);
                  setBtnConfigs([]);
                }}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="reports-controls">
        <div className="section-title">{activeTab}</div>

        <div className="button-group">
          {(canEdit ? btnConfigs : []).map((btn, index) => (
            <Button
              key={index}
              type={btn.type || "primary"}
              icon={btn.icon}
              onClick={btn.onClick}
              className={`custom-action-btn ${btn.className || ""}`}
            >
              {btn.text}
            </Button>
          ))}
        </div>
      </div>

      <div className="tab-content">
        {activeTab === "Transactions" && (
          <VendorTransactions
            setBtnConfigs={setBtnConfigs}
            setExportData={setExportData}
            transactions={transactions}
          />
        )}
        {activeTab === "Transaction Adjustments" && (
          <TransactionAdjustments
            setBtnConfigs={setBtnConfigs}
            setExportData={setExportData}
          />
        )}
      </div>
    </div>
  );
};

export default Transactions;
